<template>
  <ul class="k3No">
    <li v-for="(item, index) in drawList" :key="index" :class="'k3No' + item" v-if="LotteryLatelyLpVo.length > 1"></li>
    <li class="k3Random" v-if="LotteryLatelyLpVo.length < 1" v-for="(item,i) of 3" :key="i">
      <img src="../../assets/open_num.gif" alt="">
    </li>
    <!-- <li class="k3Random" v-if="LotteryLatelyLpVo.length < 1">
      <img src="../../assets/open_num.gif" alt="">
    </li>
    <li class="k3Random" v-if="LotteryLatelyLpVo.length < 1">
      <img src="../../assets/open_num.gif" alt="">
    </li> -->
  </ul>

</template>
<script>
import lotteryRandBallDF from "~/mixins/lotteryRandBallDF.mixins";
import lhcMixins from "~/mixins/lhc.mixins";
export default {
  mixins: [lotteryRandBallDF, lhcMixins],
  data() {
    return {
    };
  },
  props: {
    lottery: {
      type: [Object],
      default: null
    },
  },
  computed: {
    // 开奖中
    LotteryLatelyLpVo() {
      if (this.lottery) {
        return this.lottery.drawingNumber
          ? this.lottery.drawingNumber.split(",")
          : [];
      } else {
        return [];
      }
    }
  }
}
</script>
<style lang="less">
.home-menu-component-df,.record-menu-components-df,.chart-menu-components-df  {
  .k3No {
    li {
      width: 60px;
      height: 60px;
      line-height: 60px;
      text-align: center;
      margin: 20px 8px 0 0;
      background: url(../../assets/open_num.png) no-repeat center 0
    }

    img {
      width: 61px;
      height: 71px
    }

    .k3No1 {
      background-position: 50% 1.348%
    }

    .k3No2 {
      background-position: 50% 17.79%
    }

    .k3No3 {
      background-position: 50% 34.232%
    }

    .k3No4 {
      background-position: 50% 50.674%
    }

    .k3No5 {
      background-position: 50% 67.116%
    }

    .k3No6 {
      background-position: 50% 83.558%
    }

    .k3No0 {
      background-position: 50% 100%
    }

    .k3Random {
      margin: 10px 8px 0 0
    }
  }
}
</style>